module.exports = __webpack_public_path__ + "img/desktop.1768119790257.jpg";